import { trimNumber, num2str } from '@rc-component/mini-decimal';
export function getDecupleSteps(step) {
  var stepStr = typeof step === 'number' ? num2str(step) : trimNumber(step).fullStr;
  var hasPoint = stepStr.includes('.');
  if (!hasPoint) {
    return step + '0';
  }
  return trimNumber(stepStr.replace(/(\d)\.(\d)/g, '$1$2.')).fullStr;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-input-number/es/utils/numberUtil.js
// module id = 2690
// module chunks = 0